import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { NoBorderButton } from "@similarweb/ui-components";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const HeaderContainer = styled(FlexRow)`
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
`;

export const StyledNoBorderButton = styled(NoBorderButton)`
    div {
        font-size: 20px;
        color: ${colorsPalettes.blue["400"]} !important;
        svg {
            path {
                fill: ${colorsPalettes.blue["400"]} !important;
            }
        }
    }
`;

export const LobCategoryItemWrapper = styled.div<{ isSelected?: boolean }>`
    height: 44px;
    background-color: ${({ isSelected }) => (isSelected ? colorsPalettes.bluegrey[200] : "transparent")};
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    padding: 0 16px;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${({ isSelected }) =>
            isSelected ? colorsPalettes.bluegrey[200] : colorsPalettes.bluegrey[100]};
    }
`;
